<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <b-form @submit="onSubmit" @reset="onReset" novalidate="novalidate">
                    <div class="card">
                        <div class="card-header card-header-icon card-header-rose">
                            <div class="card-icon">
                                <i class="material-icons">sync</i>
                            </div>
                            <h4 class="card-title">Sincronizar Formalizações e Pós vendas</h4>
                        </div>
                        <div class="card-body">
                            <div class="row" v-if="hasErrors">
                                <div class="col-md-12">
                                    <b-list-group>
                                        <b-list-group-item variant="danger" v-for="err in errors">{{ err }}</b-list-group-item>
                                    </b-list-group>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group bmd-form-group is-filled" v-bind:class="{'has-danger' : validation.date_at != null}">
                                        <label for="interval" class="bmd-label-floating">Intervalo</label>
                                        <date-picker
                                            v-model="form.date_at"
                                            lang="pt-br"
                                            format="DD/MM/YYYY"
                                            placeholder="Escolha uma data"
                                            v-bind:class="{'has-danger' : validation.date_at != null}"
                                            >
                                        </date-picker>
                                        <br />
                                        <label v-if="validation.date_at != null" id="date_at-error" class="error" for="date_at">{{ validation.date_at }}</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer">
                            <button type="reset" class="btn btn-fill btn-outline-danger">Limpar</button>
                            <button type="submit" class="btn btn-fill btn-rose">Sincronizar</button>
                        </div>
                    </div>
                </b-form>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                errors: [],
                form: {
                    date_at: new Date(),
                },
                hasErrors: false,
                validation: {
                    date_at: null
                }
            };
        },
        methods: {
            onReset: function (_ev) {
                _ev.preventDefault();

                this.validation.date_at = null;

                this.form.date_at = new Date();
            },
            onSubmit: function (_ev) {
                _ev.preventDefault();

                var self = this;
                var valid = true;
                self.validation.date_at = null;

                if (self.form.date_at == null || self.form.date_ate == "") {
                    self.validation.date_at = "Favor informar a data a ser usada para sincronizar os dados";
                    valid = false;
                }

                if (valid) {
                    self.$root.$emit("onLoading");

                    const response = self.$store.dispatch("syncContractsAndAfterSales/execute", self.form);

                    response.then(response => {
                        self.$root.$emit("onLoading");
                    });

                    response.catch(function (_errors) {
                        self.$root.$emit("onLoading");
                    });
                }
            }
        }
    };
</script>
